export const offeringSkus = {
	free: 'teamwork-collection-free-sku',
	standard: 'teamwork-collection-standard-sku',
	premium: 'teamwork-collection-premium-sku',
	enterprise: 'teamwork-collection-enterprise-sku',
};
